export const brl = (v) =>
  "R$ " + Number(v || 0).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const pct = (v, d = 1) =>
  v === null || v === undefined ? "—" : Number(v).toLocaleString("pt-BR", { minimumFractionDigits: d, maximumFractionDigits: d }) + "%";

export const num = (v, d = 3) => Number(v || 0).toLocaleString("pt-BR", { maximumFractionDigits: d });

export const dm = (iso) => (iso ? `${iso.slice(8, 10)}/${iso.slice(5, 7)}` : "");

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString("pt-BR") : "");

export const fmtDateTime = (iso) =>
  iso ? new Date(iso).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }) : "";

export const parseNum = (s) => {
  if (s === null || s === undefined || s === "") return 0;
  const n = parseFloat(String(s).replace(/\./g, (m, i, str) => (str.includes(",") ? "" : m)).replace(",", "."));
  return Number.isFinite(n) ? n : 0;
};

export const numStr = (v) => (v === null || v === undefined || v === 0 ? "" : String(v).replace(".", ","));

export const PERIODS = { semanal: { name: "Semana", last: "Última semana", adj: "semanal" }, quinzenal: { name: "Quinzena", last: "Última quinzena", adj: "quinzenal" }, mensal: { name: "Mês", last: "Último mês", adj: "mensal" } };
const per = (c) => PERIODS[c?.period] || PERIODS.semanal;
export const periodName = (c) => per(c).name;
export const lastPeriodLabel = (c) => per(c).last;
export const weekLabel = (c) => `${periodName(c)} ${dm(c.week_start)} – ${dm(c.week_end)}`;

export const cmvTone = (p, target) => (p === null || p === undefined ? "muted" : p > target ? "warning" : "success");
